<template>
  <div class="daily-details-view" v-cloak>
    <span class="daily-details-header">{{ dailyData.work_date + " / " + dailyData.employee_name }}</span>
    <DxDataGrid
      key-expr="uuid"
      :ref="gridRefKey"
      :data-source="dailyData.works"
      :column-min-width="50"
      :show-column-lines="true"
      :show-row-lines="true"
      :show-borders="true"
      :column-auto-width="false"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :row-alternation-enabled="true"
      :hover-state-enabled="true"
      :columns="gridColumns"
      :element-attr="gridAttributes"
      :row-height="50"
    >
    </DxDataGrid>
  </div>
</template>

<script>
import DxDataGrid from "devextreme-vue/data-grid";

export default {
  name: "ScDailyReportDetailList",
  components: {
    DxDataGrid,
  },
  props: {
    dailyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      gridAttributes: {
        class: "sc-daily-report-detail-list-dxgrid",
      },
      gridRefKey: "dailyReportDetailListDxGrid",
    };
  },
  computed: {
    gridColumns() {
      const headers = [
        { name: this.$t("common.work_name"), key: "work_name", align: "center", sortable: false },
        {
          name: this.$t("common.work_hours"),
          key: "calculated_active_work_hours_utc",
          align: "center",
          sortable: false,
        },
        { name: this.$t("common.work_group"), key: "work_group_name", sortable: false },
        {
          name: this.$t("salary_calculator.reports.table.hectare"),
          key: "hectare_worked",
          align: "center",
          sortable: false,
          dataType: "number",
          format: { type: "fixedPoint", precision: 2 },
        },
        {
          name: this.$t("salary_calculator.reports.table.idle_engine_time"),
          key: "inactive_work_hours_utc",
          align: "center",
          sortable: false,
        },
        {
          name: this.$t("salary_calculator.reports.table.tariff"),
          key: "tariff",
          align: "center",
          sortable: false,
          dataType: "number",
          format: { type: "fixedPoint", precision: 2 },
        },
        {
          name: this.$t("salary_calculator.reports.table.cost"),
          key: "cost",
          align: "center",
          sortable: false,
          dataType: "number",
          format: { type: "fixedPoint", precision: 2 },
        },
      ];
      return (headers || [])
        .filter((h) => h && h.key)
        .map((h) => {
          return {
            dataField: h.key,
            caption: h.name,
            alignment: h.align || undefined,
            allowSorting: h.sortable !== false,
            dataType: h.dataType || undefined,
            format: h.format || undefined,
          };
        });
    },
  },
  methods: {
    getGridColumns() {
      return this.$refs[this.gridRefKey]?.instance?.getVisibleColumns();
    },
  },
};
</script>

<style scoped>
.daily-details-view {
  padding-right: 15px;
  margin-bottom: 20px;
}

.daily-details-header {
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 10px;
  display: block;
  width: 50%;
}

.sc-daily-report-detail-list-dxgrid {
  width: 95%;
}
</style>
